





























import Vue from 'vue';
import DateRangePicker from 'vue2-daterange-picker';
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
import moment from 'moment';

export default Vue.extend({
  name: 'HMDatePicker',
  components: {
    DateRangePicker,
  },
  props: {
    value: {
      type: Object as () => DatePicker,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    showClear: {
      type: Boolean,
      default: false,
    },
    hideDefaultDateRanges: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    defaultRanges() {
      if (this.hideDefaultDateRanges) {
        return false;
      }
      const today = moment().startOf('day');
      const endOfToday = moment().endOf('day');
      const yesterday = today.clone().subtract(1, 'days');
      const endOfYesterday = endOfToday.clone().subtract(1, 'days');

      const startOfThisWeek = today.clone().startOf('week');
      const endOfThisWeek = today.clone().endOf('week').endOf('day');

      const sevenDaysAgo = today.clone().subtract(7, 'days');
      const startOfLastWeek = sevenDaysAgo.clone().startOf('week');
      const endOfLastWeek = sevenDaysAgo.clone().endOf('week').endOf('day');

      const thisMonthStart = today.clone().startOf('month');
      const thisMonthEnd = today.clone().endOf('month').endOf('day');

      const lastMonth = today.clone().subtract(1, 'months');
      const lastMonthStart = lastMonth.clone().startOf('month');
      const lastMonthEnd = lastMonth.clone().endOf('month').endOf('day');

      const currentQuarter = today.clone().quarter(moment().quarter());
      const currentQuarterStart = currentQuarter.clone().startOf('quarter');
      const currentQuarterEnd = currentQuarter
        .clone()
        .endOf('quarter')
        .endOf('day');

      const quarterAdjustment = (today.month() % 3) + 1;
      const lastQuarterDate = today
        .clone()
        .subtract({ months: quarterAdjustment });
      const lastQuarter = lastQuarterDate
        .clone()
        .quarter(lastQuarterDate.quarter());
      const lastQuarterStart = lastQuarter.clone().startOf('quarter');
      const lastQuarterEnd = lastQuarter.clone().endOf('quarter').endOf('day');

      const startOfYear = today.clone().startOf('year');
      const endOfYear = today.clone().endOf('year').endOf('day');

      const lastYearFromToday = today.clone().subtract(1, 'years');
      const startOfLastYear = lastYearFromToday.clone().startOf('year');
      const endOfLastYear = lastYearFromToday
        .clone()
        .endOf('year')
        .endOf('day');

      const startOfAllTime = moment('01/01/2015', 'DD/MM/YYYY').startOf('day');

      const ranges = {};
      ranges[`${this.$t('GENERAL.LABEL.TODAY')}`] = [
        today.toDate(),
        endOfToday.toDate(),
      ];
      ranges[`${this.$t('GENERAL.LABEL.YESTERDAY')}`] = [
        yesterday.toDate(),
        endOfYesterday.toDate(),
      ];
      ranges[`${this.$t('GENERAL.LABEL.THIS_WEEK')}`] = [
        startOfThisWeek.toDate(),
        endOfThisWeek.toDate(),
      ];
      ranges[`${this.$t('GENERAL.LABEL.LAST_WEEK')}`] = [
        startOfLastWeek.toDate(),
        endOfLastWeek.toDate(),
      ];
      ranges[`${this.$t('GENERAL.LABEL.THIS_MONTH')}`] = [
        thisMonthStart.toDate(),
        thisMonthEnd.toDate(),
      ];
      ranges[`${this.$t('GENERAL.LABEL.LAST_MONTH')}`] = [
        lastMonthStart.toDate(),
        lastMonthEnd.toDate(),
      ];
      ranges[`${this.$t('GENERAL.LABEL.THIS_QUARTER')}`] = [
        currentQuarterStart.toDate(),
        currentQuarterEnd.toDate(),
      ];
      ranges[`${this.$t('GENERAL.LABEL.LAST_QUARTER')}`] = [
        lastQuarterStart.toDate(),
        lastQuarterEnd.toDate(),
      ];
      ranges[`${this.$t('GENERAL.LABEL.THIS_YEAR')}`] = [
        startOfYear.toDate(),
        endOfYear.toDate(),
      ];
      ranges[`${this.$t('GENERAL.LABEL.LAST_YEAR')}`] = [
        startOfLastYear.toDate(),
        endOfLastYear.toDate(),
      ];
      ranges[`${this.$t('GENERAL.LABEL.ALL_TIME')}`] = [
        startOfAllTime.toDate(),
        endOfToday.toDate(),
      ];

      return ranges;
    },
  },
  data() {
    return {
      dateRange: {
        startDate: null,
        endDate: null,
      } as DatePicker,
    };
  },
  mounted() {
    this.dateRange = this.value;
  },
  watch: {
    dateRange: {
      handler(value: DatePicker) {
        this.$emit('input', value);
      },
    },
  },
  filters: {
    date: function (value: Date): string {
      if (!value) return '';
      return moment(value).format('MMM DD, yyyy');
    },
  },
  methods: {
    clear(): void {
      this.dateRange = {
        startDate: null,
        endDate: null,
      };
    },
  },
});
